import React from 'react';
import { FundSummary } from 'src/types';
import { agreementTypeToDisplay } from 'src/utils/funds/funds-utility';
import styles from './styles.module.scss';

export const FundSummaryDisplay: React.FC<FundSummary> = ({
  agreementNumber = '',
  agreementType,
  displayClassification = '',
  formattedEntityNames,
  fundName,
  ticker,
}) => {
  const displayType = `${agreementTypeToDisplay(
    displayClassification || ''
  )} / ${agreementTypeToDisplay(agreementType)}`;
  return (
    <React.Fragment>
      <div className={styles['condensed-type']}>{displayType}</div>
      <div className={styles['condensed-fund-name']}>
        {fundName}
        <span className={styles['condensed-ticker']}>{ticker}</span>
      </div>
      <footer className={`${styles['condensed-info']} blocked_data`}>
        {agreementNumber} &#8226; {formattedEntityNames}
      </footer>
    </React.Fragment>
  );
};
